import { render, staticRenderFns } from "./modal-user-photos.vue?vue&type=template&id=10253db5"
import script from "./modal-user-photos.vue?vue&type=script&lang=js"
export * from "./modal-user-photos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports